export enum ShippingMethodPricingType {
    Fixed = 'fixed',
    Free = 'free',
    Matrix = 'matrix',
}